import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { applyMiddleware, combineReducers, compose, createStore } from 'redux'
import thunk from 'redux-thunk'
import App from './containers/App'
import ErrorBoundary from './components/ErrorBoundary'
import * as serviceWorker from './serviceWorker'
import sprawozdanie from './store/reducers/sprawozdanie'
import IndexStyle from './styles/IndexStyle'
import { ThemeProvider } from 'styled-components'
import GlobalStyle, { theme } from './styles/GlobalStyle'
import { MuiThemeProvider } from '@material-ui/core/styles'
import IEInfo from './containers/IEInfo'

const composeEnhancers =
  process.env.NODE_ENV === 'development' &&
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : null || compose

const reducer = combineReducers({
  sprawozdanie,
})

const store = createStore(reducer, composeEnhancers(applyMiddleware(thunk)))
const app =
  false || !!document.documentMode ? (
    <IEInfo />
  ) : (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <MuiThemeProvider theme={theme}>
          <>
            <GlobalStyle />
            <IndexStyle className="index">
              <ErrorBoundary>
                <App />
              </ErrorBoundary>
            </IndexStyle>
          </>
        </MuiThemeProvider>
      </ThemeProvider>
    </Provider>
  )

ReactDOM.render(app, document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()
